import { render } from "./ButtonGroup.vue?vue&type=template&id=a503ccb0"
import script from "./ButtonGroup.vue?vue&type=script&lang=js"
export * from "./ButtonGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/ButtonGroup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a503ccb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a503ccb0', __exports__)) {
    api.reload('a503ccb0', __exports__)
  }
  
  module.hot.accept("./ButtonGroup.vue?vue&type=template&id=a503ccb0", () => {
    api.rerender('a503ccb0', render)
  })

}


export default __exports__